import {
  UPDATE_CONTACTBLOCK,
  UPDATE_CONTACTBLOCK_SUCCESS,
  UPDATE_CONTACTBLOCK_ERROR,

  UPDATE_ORDER_CONTACTBLOCK,
  UPDATE_ORDER_CONTACTBLOCK_SUCCESS,
  UPDATE_ORDER_CONTACTBLOCK_ERROR,
  
  GET_CONTACTBLOCK_LIST,
  GET_CONTACTBLOCK_LIST_SUCCESS,
  GET_CONTACTBLOCK_LIST_ERROR,

  GET_CONTACTBLOCK,
  GET_CONTACTBLOCK_SUCCESS,
  GET_CONTACTBLOCK_ERROR,

  SAVE_CONTACTBLOCK,
  SAVE_CONTACTBLOCK_SUCCESS,
  SAVE_CONTACTBLOCK_ERROR,

  GET_ORDER_CONTACTBLOCK,
  GET_ORDER_CONTACTBLOCK_SUCCESS,
  GET_ORDER_CONTACTBLOCK_ERROR,
  
  CREATE_CONTACTBLOCK,
  CREATE_CONTACTBLOCK_SUCCESS,
  CREATE_CONTACTBLOCK_ERROR,
  
  DELETE_CONTACTBLOCK,
  DELETE_CONTACTBLOCK_SUCCESS,
  DELETE_CONTACTBLOCK_ERROR,

} from "../actions";

const INIT_STATE = {
  contactBlock: null,
  contactBlockList : null,
  contactId : null,
  recordType : null,
  orderId : null,
  progressIcon: false,
  createProgress: false,
  orderContactBlock: null,
  savedcontactBlock : null,

};


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_CONTACTBLOCK:
      return { ...state, loading: true, error: "", isSagaExecuted: false, contactBlock: action.payload.contactBlock };
    case UPDATE_CONTACTBLOCK_SUCCESS:
      return { ...state, loading: false,  isSagaExecuted: false, error: "", contactBlock: action.payload };
    case UPDATE_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false, isSagaExecuted: false, error: action.payload.message };      
    case UPDATE_ORDER_CONTACTBLOCK:
      return { ...state, loading: true, isSagaExecuted: false, error: "", orderContactBlock: action.payload.contactBlock };
    case UPDATE_ORDER_CONTACTBLOCK_SUCCESS:
      return { ...state, loading: false, isSagaExecuted: false, error: "", orderContactBlock: action.payload };
    case UPDATE_ORDER_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false, isSagaExecuted: false, error: action.payload.message }; 
    case GET_CONTACTBLOCK_LIST:
      return { ...state, loading: true, 
       progressIcon: true, error: "",
       recordState: action.payload.recordState,
       recordType: action.payload.recordType,
       contactId: action.payload.contactId, 
       orderId: action.payload.orderId,
       isSagaExecuted: false,
      };
    case GET_CONTACTBLOCK_LIST_SUCCESS:
      return { ...state, loading: false, isSagaExecuted:false,progressIcon : false, error: "", contactBlockList: action.payload };
    case GET_CONTACTBLOCK_LIST_ERROR:    
        return { ...state, loading: false, isSagaExecuted:false, error: action.payload.message, progressIcon:false };    
    case GET_CONTACTBLOCK:
      return { ...state, loading: true, error: "", contactBLockId: action.payload.contactBLockId };
    case GET_CONTACTBLOCK_SUCCESS:
      return { ...state, loading: false, error: "", contactBlock: action.payload };
    case GET_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false, error: action.payload.message };     
    case GET_ORDER_CONTACTBLOCK:
      return { ...state, loading: true, error: "", contactBLockId: action.payload.contactBLockId };
    case GET_ORDER_CONTACTBLOCK_SUCCESS:
      return { ...state, loading: false, error: "", orderContactBlock: action.payload };
    case GET_ORDER_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false, error: action.payload.message }; 
    case CREATE_CONTACTBLOCK:
      return { ...state, loading: true, isSagaExecuted:false, createProgress : true, error: "", contactBlock: action.payload.cb };
    case CREATE_CONTACTBLOCK_SUCCESS:
      return { ...state, loading: false, isSagaExecuted:false, error: "",createProgress:false, contactBlock: action.payload };
    case CREATE_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false,isSagaExecuted:false, createProgress:false, error: action.payload.message };   
    case SAVE_CONTACTBLOCK:
      return { ...state, loading: true, isSagaExecuted: false, createProgress : true, error: "", savedcontactBlock: action.payload.cb };
    case SAVE_CONTACTBLOCK_SUCCESS:
      return { ...state, loading: false, isSagaExecuted: false, error: "",createProgress:false, savedcontactBlock: action.payload };
    case SAVE_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false, isSagaExecuted: false,createProgress:false, error: action.payload.message };                                   
    case DELETE_CONTACTBLOCK:
      return { ...state, loading: true, isSagaExecuted: false, error: "", contactBlock: action.payload.cb };
    case DELETE_CONTACTBLOCK_SUCCESS:
      let updatedContactBlockListOnDelete = { ...(state.contactBlockList) };
      updatedContactBlockListOnDelete = state.contactBlockList ? [...state.contactBlockList] : [];
      updatedContactBlockListOnDelete = updatedContactBlockListOnDelete.filter(cb => cb.contactBlockId != action.payload.contactBlockId);
      return { ...state, loading: false, isSagaExecuted:false, error: "", contactBlockList: updatedContactBlockListOnDelete };
    case DELETE_CONTACTBLOCK_ERROR:    
        return { ...state, loading: false, isSagaExecuted:false,  error: action.payload.message };                                   
    default:
      return { ...state };
  }
};
